import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const FAQ = () => {
  const [expandedFAQ, setExpandedFAQ] = useState(null);

  return (
    <div className="faq-page">
      {/* Hero Banner */}
      <section className="py-20 bg-gradient-to-r from-blue-900 via-blue-800 to-blue-900 relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <img 
            src="https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1920" 
            alt="FAQ" 
            className="w-full h-full object-cover"
          />
        </div>
        <div className="max-w-7xl mx-auto px-4 relative z-10 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Frequently Asked <span className="text-green-500">Questions</span>
          </h1>
          <p className="text-white text-xl max-w-3xl mx-auto">
            Find answers to common questions about our services and how we can help your business grow.
          </p>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4">
          <FAQSection expandedFAQ={expandedFAQ} setExpandedFAQ={setExpandedFAQ} />
        </div>
      </section>

      {/* Still Have Questions CTA */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Still Have <span className="text-green-600">Questions?</span>
          </h2>
          <p className="text-gray-600 text-lg mb-8">
            Can't find the answer you're looking for? Our team is here to help!
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-blue-600 text-white px-8 py-3 rounded-full hover:bg-blue-700 transition-colors font-medium"
          >
            Contact Us →
          </Link>
        </div>
      </section>
    </div>
  );
};

// FAQ Section Component (moved outside)
const FAQSection = ({ expandedFAQ, setExpandedFAQ }) => {
  const faqs = [
    {
      category: "General",
      questions: [
        {
          question: "What services does Plexgate offer?",
          answer: "Plexgate offers Application Development, Cybersecurity, Web Development, IT/Desktop Support, Cloud Solutions, IT Consultation & Auditing, Creative Design, Tech Training, and Tech Recruitment."
        },
        {
          question: "Where is Plexgate located?",
          answer: "We are located at 1962 Foxridge Cres, London ON, N6G 0L8, Canada. We serve clients globally through remote services."
        },
        {
          question: "How can I get a quote?",
          answer: "Request a free consultation via our Contact page or call 1-647-524-7336 for a customized quote."
        }
      ]
    },
    {
      category: "Services",
      questions: [
        {
          question: "Do you work with businesses of all sizes?",
          answer: "Yes! We work with startups, small businesses, and large enterprises. Solutions are tailored to your needs and budget."
        },
        {
          question: "What is your typical project timeline?",
          answer: "Simple projects take 2-4 weeks, while larger implementations can take 3-6 months. Timelines are provided during consultation."
        },
        {
          question: "Do you provide ongoing support?",
          answer: "Yes! We offer maintenance packages including updates, bug fixes, monitoring, and technical assistance."
        },
        {
          question: "Can you help migrate to the cloud?",
          answer: "Absolutely! We specialize in cloud migration for AWS, Azure, and Google Cloud from assessment to deployment."
        }
      ]
    },
    {
      category: "Tech Training",
      questions: [
        {
          question: "Do I need prior experience?",
          answer: "No! Our programs are for beginners and advanced learners. We start with fundamentals and build to advanced topics."
        },
        {
          question: "What is the class format?",
          answer: "Hybrid approach with live online classes, recorded sessions, hands-on labs, and real-world projects in small groups."
        },
        {
          question: "Do you provide job placement assistance?",
          answer: "Yes! We offer resume reviews, portfolio development, interview prep, and connections to hiring partners."
        }
      ]
    },
    {
      category: "Pricing",
      questions: [
        {
          question: "How much do services cost?",
          answer: "Pricing varies by project scope and complexity. We offer flexible packages. Contact us for a customized quote."
        },
        {
          question: "Do you offer payment plans?",
          answer: "Yes! We offer flexible payment plans. Contact us to discuss options that work for your budget."
        }
      ]
    }
  ];

  return (
    <div>
      {faqs.map((category, categoryIndex) => (
        <div key={categoryIndex} className="mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">{category.category}</h2>
          <div className="space-y-4">
            {category.questions.map((faq, index) => {
              const globalIndex = `${categoryIndex}-${index}`;
              return (
                <div key={index} className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm">
                  <button
                    onClick={() => setExpandedFAQ(expandedFAQ === globalIndex ? null : globalIndex)}
                    className="w-full px-6 py-4 flex justify-between items-center text-left hover:bg-gray-50 transition-colors"
                  >
                    <span className="font-semibold text-lg text-gray-900 pr-4">{faq.question}</span>
                    <span className="text-2xl text-gray-600 flex-shrink-0">
                      {expandedFAQ === globalIndex ? '−' : '+'}
                    </span>
                  </button>
                  {expandedFAQ === globalIndex && (
                    <div className="px-6 py-4 bg-gray-50 border-t border-gray-200">
                      <p className="text-gray-600">{faq.answer}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQ;